module.exports = __webpack_public_path__ + "img/actel.f475748f.jpg";